import Vue from 'vue';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Supports',
  components: {
    SupportComp: require('./support.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      supports: [],
      supportServices: [],
      supportServiceTypes: [],
      teams: [],
      stations: [],
      bSupportDialog: false,
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      editingSupport: {

      },
      editingSupportClone: {

      },
      message: '',
    }
  },
  created() {
    //console.log("supports data", this.dataObj.appData);
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - parseInt(i)).toFixed(decPlaces).slice(2) : "");
    }, //this.formatMoney(item.closingBalance, 2, '.', ',');
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.actualSupportUsages.forEach(p => {
          p.totalCost = this.formatMoney(p.totalCost, 2, '.', ',');
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });
        if (this.dataObj.appData.actualSupportUsages)
          this.supports = this.dataObj.appData.actualSupportUsages;
        else
          this.dataObj.appData.actualSupportUsages = [];
        this.supportServices = this.dataObj.appData.supportServices;
        this.supportServiceTypes = this.dataObj.appData.supportServiceTypes;
        this.teams = this.dataObj.appData.teams;
        this.stations = this.dataObj.appData.stations;
      });
    },
    addSupport() {
      this.editingSupportClone = {
        isMultiple: false,
        selection: [],
        additionalCost: 0,
        comment: '',
        dt: this.dataObj.appData.fromDt,
        id: 0,
        logDescription: '',
        logValue: 0,
        name: '',
        rateHr: 0,
        supportService: '',
        supportServiceId: 0,
        supportServiceType: '',
        supportServiceTypeId: 0,
        showSupportServicesRates: this.dataObj.appData.settings.showSupportServicesRates,
        totalCost: 0,
        travelDistance: 0,
        travelDuration: this.dataObj.appData.actualTravelDuration,
        workDuration: this.dataObj.appData.actualJobDuration,
        uuid: uuidv4(),
        supportServices: this.supportServices,
        supportServiceTypes: this.supportServiceTypes,
        teams: this.teams,
        stations: this.stations,
        maxJobDuration: this.dataObj.appData.actualJobDuration == null ? '0' : this.dataObj.appData.actualJobDuration,
        maxTravelDuration: this.dataObj.appData.actualTravelDuration == null ? '0' : this.dataObj.appData.actualTravelDuration,
        isEdit: false,
        stationId: this.dataObj.appData.stationId
      };
     //console.log("clone supports", this.editingSupportClone);
      this.bSupportDialog = true;
    },
    editSupport(item) {
      this.editingSupport = item;
      this.editingSupportClone = JSON.parse(JSON.stringify(item));
      this.editingSupportClone.supportServices = this.supportServices;
      this.editingSupportClone.supportServiceTypes = this.supportServiceTypes;
      this.editingSupportClone.showSupportServicesRates = this.dataObj.appData.settings.showSupportServicesRates;
      this.editingSupportClone.teams = this.teams;
      this.editingSupportClone.stations = this.stations;
      this.editingSupportClone.isMultiple = false;
      this.editingSupportClone.selection = [];
      this.editingSupportClone.maxJobDuration = this.dataObj.appData.actualJobDuration == null ? '0' : this.dataObj.appData.actualJobDuration;
      this.editingSupportClone.maxTravelDuration = this.dataObj.appData.actualTravelDuration == null ? '0' : this.dataObj.appData.actualTravelDuration;
      this.editingSupportClone.isEdit = true;

      this.bSupportDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('omApplication.DeleteSupport') + ' [' + item.id + '. ' + item.supportService + '] ?';
      this.editingSupport = item;
      this.bConfirmDialog = true;
    },
    removeSupport() {
      this.dataObj.appData.actualSupportUsages = this.dataObj.appData.actualSupportUsages.filter(p => p.uuid !== this.editingSupport.uuid);
      this.supports = this.dataObj.appData.actualSupportUsages;
    },
    saveSupport() {
      if (this.editingSupportClone.workDuration > this.editingSupportClone.maxJobDuration) {
        this.$alertMsg(this.$t('validation.invalidWorkDuration'));
        return;
      }    
     
      this.dataObj.appData.actualSupportUsages = this.dataObj.appData.actualSupportUsages.filter(p => p.uuid !== this.editingSupportClone.uuid);
      const isMultiple = this.editingSupportClone.isMultiple;
      const selection = this.editingSupportClone.selection;
      delete this.editingSupportClone.supportServices;
      delete this.editingSupportClone.showSupportServicesRates;
      delete this.editingSupportClone.supportServiceTypes;
      delete this.editingSupportClone.teams;
      delete this.editingSupportClone.stations;
      delete this.editingSupportClone.maxJobDuration;
      delete this.editingSupportClone.maxTravelDuration;

      if (isMultiple === false)
        this.dataObj.appData.actualSupportUsages.push(this.editingSupportClone);
      else {
        selection.forEach(p => {
          const support = JSON.parse(JSON.stringify(this.editingSupportClone));
          const service = this.supportServices.filter(e => e.id === p.id)[0];
          support.supportServiceId = p.id;
          support.rateHr = p.rate;
          support.supportService = service.name;
          support.uuid = uuidv4();

          this.dataObj.appData.actualSupportUsages.push(support);
        });
      }
      
      this.supports = this.dataObj.appData.actualSupportUsages;
      this.bSupportDialog = false;
    },
    closeDialog() {
      this.bSupportDialog = false;
    },
  },
  
}

